module.exports = __webpack_public_path__ + "static/media/img-1.d23f9c07.jpg";